module.exports = __webpack_public_path__ + "files/adb54e71d39b24b2eb101f3e0de9200e.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/objects-1.png
// module id = 1472
// module chunks = 60